<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/24CH/24CH.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">24CH DSP Amplifier</div>
                <div class="detail-banner-desc">
                    As the highest-performance product in the three series, the 24-channel amplifier supports complex, high-order audio algorithms, such as enhanced active noise cancellation for both engine and road noise.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>
                    <div class="detail-desc">
                        <div>
                            Self developed, complete R&D team.
                        </div>
                        <div>
                            NXP high-end series full Class D digital amplifier, 2400W rated output power, 24CH audio outputs, drive up to 35 speakers.
                        </div>
                        <div>
                            High computing power, luxury audio processing.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/24CH/24CH-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">306*166*48</div>
                                    <div class="k">Size(mm)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2086</div>
                                    <div class="k">Weight(g)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2400W</div>
                                    <div class="k">Rated Power</div>
                                </div> 
                                <div class="spec-item">
                                    <div class="v">&gt90dB</div>
                                    <div class="k">SNR</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">&lt0.1%</div>
                                    <div class="k">THD+N</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Amor Space® virtual scene</div>
                                    <div class="k">Audio Function</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Stereo sound, Amor TruLogic® 2D & 3D surround, multiple sound mode experiences, Amor Pano® 7.1.4 Atmos sound</div>
                                    <div class="k">Audio Function</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/24CH/24CH-1.jpg" alt="200-1-02">
                    </div>
                </div>

                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/24CH/24CH-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item spec-item-last">
                                    <div class="v">Amor Max Immersion®4D seat rhythm</div>
                                    <div class="k">Audio Function</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">iESE simulated sound waves, advanced ENAC engine noise reduction, RNAC road noise control, DNC dynamic speed compensation.</div>
                                    <div class="k">Audio Function</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: '24CH DSP Amplifier - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/24CH.html'
};

import { createApp } from 'vue';
import App from './24CH.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./24CH.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
